import useGet from './use-get'
import useGetOne from './use-get-one'

const queries = {
  useGet: useGet.useQueryHook,
  useGetOne: useGetOne.useQueryHook,
}

export default queries
